<template>
  <div>
    <TopToolbarOpen/>
    <div :class="$style.tools">
      <el-dropdown size="small"
                   type="primary"
                   trigger="click"
                   @command="handleCommand"
                   style="padding-right: 4px;padding-top: 4px;">
        <i class="el-icon-setting"
           style="cursor: pointer;"
           @click.stop></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="takeDown">全部展开</el-dropdown-item>
          <el-dropdown-item command="takeUp">全部收起</el-dropdown-item>
          <el-dropdown-item command="configQuestionErrorMessage">配置退单原因</el-dropdown-item>
          <el-dropdown-item command="configQuestionErrorMessageToOtherBatch">退单原因配置至其他批次</el-dropdown-item>
          <el-dropdown-item @click.native="openReviewHistoryBox">查看审核历史版本</el-dropdown-item>
          <el-dropdown-item v-if="orderDetail.status == 4" command="returnReviewOrderDetail">回到待审核版本</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-alert
      v-if="isAcquireOrder"
      style="margin-top: 5px;"
      title="您占有此工单审核限时为30分钟, 过期将会自动释放。"
      type="info"
      close-text="取消占有"
      @close="onReleaseOrder">
    </el-alert>

    <config-question-error-message-dialog
      v-if="configQEMDialogVisible"
      @submit-success="configQEMSubmitSuccess"
      :visible.sync="configQEMDialogVisible"
      :batch-id="orderDetail.batchid"/>

    <config-question-error-message-to-other-batch-dialog
      v-if="configQEMTOBDialogVisible"
      :visible.sync="configQEMTOBDialogVisible"
      @submit-success="configQEMSubmitSuccess"
      :batch-id="orderDetail.batchid"
      :customer-id="orderDetail.customerid" />
  </div>
</template>

<script>
import TopToolbarOpen from './detail.vue'
import ConfigQuestionErrorMessageDialog
  from '@/views/question-error-message/components/ConfigQuestionErrorMessageDialog'

import ConfigQuestionErrorMessageToOtherBatchDialog
  from '@/views/question-error-message/components/ConfigQuestionErrorMessageToOtherBatchDialog'
import OrderReviewHistoryBox from '@/views/order-review/components/order-review-history-box'
import convert from '@views/question-editor/format/convert.js'

export default {
  components: {ConfigQuestionErrorMessageDialog, TopToolbarOpen, ConfigQuestionErrorMessageToOtherBatchDialog},
  mixins: [],
  inject: ['page'],
  props: {},
  data () {
    return {
      configQEMDialogVisible: false,
      isAcquireOrder: false,
      configQEMTOBDialogVisible: false,
    }
  },
  computed: {
    ...Vuex.mapState({
      orderDetail: state => state.orderReview.orderDetail,
    }),
    ...Vuex.mapGetters('orderReview', [
      'allowOrderReview',
    ]),
  },
  watch: {
    orderDetail () {
      if (this.orderDetail.orderid && this.allowOrderReview && this.page.readonly !== 'on') {
        this.onAcquireOrder(this.orderDetail.orderid)
      }
    },
  },
  beforeCreate () {},
  created () {},
  mounted () {},
  updated () {},
  methods: {
    ...Vuex.mapActions([]),
    handleCommand (command) {
      switch (command) {
        case 'takeUp':
          this.$emit('question-collapse', true)
          break
        case 'takeDown':
          this.$emit('question-collapse', false)
          break
        case 'configQuestionErrorMessage':
          this.configQEMDialogVisible = true
          break
        case 'configQuestionErrorMessageToOtherBatch':
          this.configQEMTOBDialogVisible = true
          break
        case 'returnReviewOrderDetail':
          // TODO: 暂时回到待审核版本
          request.common('getOrderDetail', {id: this.orderDetail.orderid}).then(({data}) => {
            this.$store.commit('orderReview/SET_ORDER_DETAIL_DATA', data)
          })
          break
      }
    },
    configQEMSubmitSuccess (message) {
      this.$store.commit('orderReview/SET_ERROR_MESSAGES', message)
    },
    onAcquireOrder (id) {
      request('acquireOrder', {id}).then(() => {
        this.isAcquireOrder = true
      }).catch((error) => {
        if (error.response && error.response.data.hasOwnProperty('msg')) {
          this.isAcquireOrder = false
          this.$notify.warning({
            title: '警告',
            message: error.response.data.msg,
            offset: 50,
            duration: 15000,
          })
        }
      })
    },
    onReleaseOrder () {
      request.common('releaseOrder', {id: this.orderDetail.orderid}).then(() => {
        this.$message.success('已取消占用此工单')
      })
    },
    openReviewHistoryBox () {
      OrderReviewHistoryBox.open(this.orderDetail.orderid).then(({data}) => {
        this.$store.commit(
          'orderReview/SET_HISTORY_ANSWERS',
          convert.convertAnswers(this.page.questions, JSON.parse(data.templateresultjson)),
        )
      })
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
.tools {
  position: absolute;
  top: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/pages/OrderReviewInfoPanel/index.vue